import React, { Component } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./_non-academic.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";
import { Row, Col, Nav, Card, Image, Tab, Form, Button } from 'react-bootstrap';
import DailyAttendanceModal from "./dailyAttendanceModal";
import { Line } from "react-chartjs-2";


const GET_ATTENDANCE_DETAILS = gql`
 query($student_mobile: String) {
    getStudentAttendance(student_mobile: $student_mobile) {
        year
        month{
          month
          no_of_present
          no_of_absent
          no_of_holidays
          no_of_days
          date{
            date
            is_holiday
            is_present
            dateStatus{
              attendance_type
              attended_status
            }
          }
        }
        }
    }
`;


var options = {
    legend: {
        display: false,
    },
    scales: {
        xAxes: [
            {
                ticks: {
                    display: true,
                },
            },
        ],
        yAxes: [
            {
                ticks: {
                    display: true,
                    beginAtZero: true,
                    stepSize: 5 // Set the step size to 10
                },
            },
        ],
    },
    tooltips: {
        enabled: true, // Enable tooltips
        mode: 'index', // Display all tooltips for overlapping points
        intersect: false, // Don't show tooltips when hovering between points
        callbacks: {
            label: function (tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel; // Customize the tooltip label
            },
        },
    },
    layout: {
        padding: {
            left: 20,
            right: 20,
            top: 10,
            bottom: 10,
        },
    },
    hover: {
        cursor: 'pointer', // Change cursor style to 'pointer'
    },
};


class NAAttendanceReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMonth: 0,
            no_of_absent: 0,
            no_of_days: 0,
            no_of_holidays: 0,
            no_of_present: 0,
            currentYear: 0,
            currentMonthData: [],
            modalShow: false,
            currentDateData: []
        }

    }


    componentDidMount() {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        this.setState({ currentMonth: currentMonth, currentYear: currentYear })
    }

    render() {

        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;

        const attendanceDetails = this.props.attendanceDetails;
        const loading1 = attendanceDetails.loading;
        const error1 = attendanceDetails.error;


        if (loading1) return <PreloaderTwo />;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        let graphData = [];

        if (attendanceDetails.getStudentAttendance.length > 0) {
            let filterAttendanceData = attendanceDetails.getStudentAttendance.filter((item) => item.year == this.state.currentYear)[0].month.filter((item1) => item1.month == this.state.currentMonth);
            // graphData = attendanceDetails.getStudentAttendance.filter((item) => item.year >= 2023)[0].month.filter((item1) => (item1.month > 5 && item1.month <= currentMonth));
            const currentYear = new Date().getFullYear();

            graphData = attendanceDetails.getStudentAttendance.filter((item) => item.year >= currentYear)[0].month.filter((item1) => (item1.month >= 1 && item1.month <= currentMonth))


            if (filterAttendanceData.length > 0) {
                this.state.no_of_absent = filterAttendanceData[0].no_of_absent
                this.state.no_of_days = filterAttendanceData[0].no_of_days
                this.state.no_of_holidays = filterAttendanceData[0].no_of_holidays
                this.state.no_of_present = filterAttendanceData[0].no_of_present

                this.state.currentMonthData = filterAttendanceData
            }
        }


        let monthAttendancePercentage = 0;

        if (this.state.no_of_days != 0) {
            monthAttendancePercentage = (((this.state.no_of_present + this.state.no_of_holidays) / (this.state.no_of_days)) * 100).toFixed(2)
        }


        const customTileContent = ({ date, view }) => {
            const colors = ["white", "tomato", "green", "#ffc107"]; // Example of different colors for each date

            let index = 0;
            let currentDisplay = false;
            let currentMonthData = this.state.currentMonthData[0].date.filter((item) => item.date == date.getDate());


            currentMonthData.map((item) => {
                if (item.is_holiday) {
                    index = 3;
                    currentDisplay = true
                } else if (item.is_present) {
                    index = 2
                    currentDisplay = true
                } else if (!item.is_present && item.dateStatus.length > 0) {
                    index = 1
                    currentDisplay = true
                }
            })

            //console.log("date.getDate()", date.getDate(), date.getMonth() + 1, currentMonthData);


            // Get the index based on the date
            const customDotColor = colors[index]; // Get the color for the dot

            const minDate = new Date(2023, 5, 1);
            const maxDate = new Date();

            if (
                view === "month" &&
                !date.isDisabled &&
                date >= minDate &&
                date <= maxDate &&
                currentDisplay
            ) {
                return (
                    <div className="react-calendar__tile--custom-dot">
                        <span
                            style={{ "--custom-dot-color": customDotColor }}
                            className="react-calendar__tile-dot"
                        ></span>
                    </div>
                );
            }
            return null;
        };


        const tileClassName = ({ date, view }) => {
            if (view === "month") {
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth();

                return date.getFullYear() !== currentYear || date.getMonth() !== currentMonth
                    ? "react-calendar__tile--hidden"
                    : "";
            }

            return "";
        };

        const changeDate = activeStartDate => {
            const currentMonth = activeStartDate.activeStartDate.getMonth() + 1;
            const currentYear = activeStartDate.activeStartDate.getFullYear();
            this.setState({ currentMonth, currentYear })
        };

        const displayPopup = date => {

            let currentDate = this.state.currentMonthData[0].date.filter((item) => item.date == date.getDate())

            if (currentDate[0].dateStatus.length > 0) {
                this.setState({
                    modalShow: true,
                    currentDateData: currentDate[0].dateStatus
                })

            }
        }


        let monthNames = [];
        let presentDays = [];

        if (graphData.length > 0) {
            graphData.map((item) => {
                // console.log("monthdddddd",item)


                function getMonthName(monthNumber) {
                    const date = new Date();
                    date.setMonth(monthNumber - 1);

                    return date.toLocaleString('en-US', { month: 'long' });
                }

                let month = getMonthName(item.month);
                // console.log("monthdddddd",item.month)

                monthNames.push(month);
                presentDays.push(item.no_of_present)
            })

        }

        const data = {
            labels: monthNames,
            datasets: [
                {
                    label: "Present",
                    fill: false,
                    borderColor: "black",
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 4,
                    data: presentDays,
                },
            ],
        };


        return (
            <div className="attendance_detials mt-3">

                <Row>
                    <Col>
                        <h4 className="mb-2 text-center">Attendance Report</h4>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} lg={6}>
                        <div style={{ overflow: 'auto', width: '100%', marginRight: "50px" }} className="chart-container">
                            <Line
                                data={data}
                                options={options}

                            />
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={6} className="calender_display">
                        <Calendar
                            minDate={new Date(2023, 5, 1)}
                            maxDate={new Date()}
                            className="custom-calendar"
                            tileContent={customTileContent}
                            tileClassName={tileClassName}
                            onActiveStartDateChange={changeDate}
                            onChange={displayPopup}

                        />
                        <Row>
                            <Col>
                                <h6 className="mt-4 text-center">Attendance Percentage : {monthAttendancePercentage}%</h6></Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col sm={3} className="overall_block class_block text-center">
                                <h6>Total Classes</h6>
                                <h6>{this.state.no_of_days}</h6>
                            </Col>
                            <Col sm={3} className="overall_block holiday_block">
                                <h6>Holidays</h6>
                                <h6>{this.state.no_of_holidays}</h6>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col sm={3} className="overall_block present_block" >
                                <h6>Total Present</h6>
                                <h6>{this.state.no_of_present}</h6>
                            </Col>
                            <Col sm={3} className="overall_block absent_block">
                                <h6>Total Absent</h6>
                                <h6>{this.state.no_of_absent}</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <DailyAttendanceModal
                    stateData={this.state.currentDateData}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                />

            </div>
        );
    }
};

export default withRouter(
    compose(
        graphql(
            GET_ATTENDANCE_DETAILS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString()
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "attendanceDetails"
            }
        )
    )(NAAttendanceReports)
);
